import { fetchApi, postApi } from 'api/fetchApi'
import { paths } from 'api/generated/showcase_v2'
interface CustomParams {
  phone: number
}

type Post = paths['/billing/v2/requestPayment']
type RequestParametersPost = Post['post']['parameters']['body']['body']
export type ResponseParametersPost = Post['post']['responses']['200']['schema']

export const requestPaymentApi = (
  paymentType: string,
  orderId: string,
  options?: CustomParams
) =>
  postApi<ResponseParametersPost, RequestParametersPost>(
    '/billing/v2/requestPayment',
    { paymentType, orderId, ...options }
  )

type Get = paths['/billing/v2/payment_type_list/{orderId}']

export type ResponseParametersGet = Get['get']['responses']['200']['schema']

export const fetchPaymentTypeListApi = (orderId: string) =>
  fetchApi<ResponseParametersGet>(
    `/billing/v2/payment_type_list/${orderId}` as keyof paths
  )
